export const defaultDataCollection = {
    add: {
        events: [],
        markets: []
    },
    change: {
        events: [],
        markets: []
    },
    delete: {
        events: [],
        markets: []
    }
};
//# sourceMappingURL=DataCollection.js.map